/*
  Contador da faixa de reserva da gaveta ("Secure your order • Reservation: MM:SS").

  Por que o número é assumido aqui e não pela classe do tema de referência
  ---------------------------------------------------------------------------
  A CountdownTimer do bundle desenha uma vez no construtor e só liga o intervalo
  em dois casos: data-auto-play="true" no HTML, ou alguém chamar playTimer(). Na
  referência quem chama é o open() da gaveta do próprio tema; aqui a gaveta é
  aberta pelo bv-cart-adapter, que troca as classes na mão, então esse playTimer()
  nunca acontece e o número ficaria parado no valor inicial.
  Mesmo se fosse chamado, a classe conta somando ticks de setInterval (aba em
  segundo plano é estrangulada e o relógio atrasa), recomeça da duração cheia a
  cada redesenho da gaveta e, ao chegar a zero, salta para 01:30 e passa a girar
  nesse laço de um minuto e meio.

  O prazo é do cliente, não da renderização
  ---------------------------------------------------------------------------
  Guarda-se o INSTANTE em que a reserva vence e o restante sai sempre da
  diferença para o relógio real. Assim a gaveta pode ser redesenhada pela Section
  Rendering API (adicionar, remover, mudar quantidade) e o cliente pode navegar
  entre páginas que o contador continua de onde estava.

  Nunca 00:00 (a correção desta rodada)
  ---------------------------------------------------------------------------
  A versão anterior congelava em 00:00 quando o prazo vencia e mantinha esse
  congelamento por 30 minutos. Uma faixa que anuncia "Reservation: 00:00" é pior
  do que não ter faixa nenhuma: alem de parecer defeito, desmente a própria
  promessa bem na hora da decisão de compra.
  Agora, ao vencer, um prazo novo começa na hora. O cliente vê o contador
  renovado, que é exatamente o que a referência faz de outro jeito (lá o prazo
  recomeça inteiro a cada carregamento de página e a cada redesenho da gaveta).
  Esconder a faixa foi descartado: tira do lugar um elemento que a referência
  mostra sempre, encolhe a gaveta na frente do cliente e deixa o carrinho sem
  nenhum sinal de urgência justamente no momento em que ele mais pesa.

  Carrinho vazio zera a reserva: a reserva é do que está no carrinho. Enquanto
  não há item, a faixa mostra o prazo cheio e o prazo anterior é descartado, para
  que o próximo item comece com o relógio inteiro.
*/
(function () {
  if (window.__dlCartTimer) return;
  window.__dlCartTimer = true;

  var PREFIXO = 'dl:cart-timer:'; // a duração entra na chave: mudou no editor, o prazo recomeça

  var prazos = {}; // cache em memória: dentro da mesma página não relê o storage a cada segundo
  var memoria = {}; // usado quando o navegador recusa o storage (aba anônima, cookies bloqueados)
  var deposito; // localStorage, sessionStorage ou nada, decidido na primeira leitura

  function armazem() {
    if (deposito !== undefined) return deposito;
    deposito = null;
    var teste = PREFIXO + 'teste';
    var candidatos = ['localStorage', 'sessionStorage'];
    for (var i = 0; i < candidatos.length; i++) {
      try {
        var s = window[candidatos[i]];
        s.setItem(teste, '1');
        s.removeItem(teste);
        deposito = s;
        break;
      } catch (e) {}
    }
    return deposito;
  }

  function ler(chave) {
    var s = armazem();
    if (!s) return memoria[chave];
    try {
      return s.getItem(chave);
    } catch (e) {
      return memoria[chave];
    }
  }

  function gravar(chave, valor) {
    memoria[chave] = String(valor);
    var s = armazem();
    if (!s) return;
    try {
      s.setItem(chave, String(valor));
    } catch (e) {}
  }

  function apagar(chave) {
    delete memoria[chave];
    var s = armazem();
    if (!s) return;
    try {
      s.removeItem(chave);
    } catch (e) {}
  }

  function comecarPrazo(duracao) {
    var prazo = Date.now() + duracao * 1000;
    prazos[duracao] = prazo;
    gravar(PREFIXO + duracao, prazo);
    return prazo;
  }

  function prazoDe(duracao) {
    var agora = Date.now();
    var prazo = prazos[duracao];

    if (!prazo) {
      var salvo = parseInt(ler(PREFIXO + duracao), 10);
      // o prazo guardado só vale se ainda estiver no futuro e dentro da própria
      // duração (acima disso é relógio do aparelho mexido ou valor corrompido)
      if (isFinite(salvo) && salvo > agora && salvo <= agora + duracao * 1000) prazo = prazos[duracao] = salvo;
      else return comecarPrazo(duracao);
    }

    // venceu enquanto a página estava aberta, ou o relógio do aparelho andou
    // para trás: começa um prazo novo em vez de exibir 00:00
    if (prazo <= agora || prazo > agora + duracao * 1000) return comecarPrazo(duracao);
    return prazo;
  }

  function esquecerPrazo(duracao) {
    if (!(duracao in prazos) && ler(PREFIXO + duracao) == null) return;
    delete prazos[duracao];
    apagar(PREFIXO + duracao);
  }

  // O sinal é o conteúdo, não a classe is-empty do elemento: no caminho de
  // "adicionar ao carrinho" o adaptador troca só o innerHTML da gaveta e deixa
  // a classe antiga no lugar. Já o bloco .drawer__inner-empty e os .cart-item
  // vêm dentro desse innerHTML, ou seja, são sempre o estado real do carrinho.
  function carrinhoVazio(el) {
    var gaveta = el.closest ? el.closest('cart-drawer') : null;
    if (!gaveta) gaveta = document.querySelector('cart-drawer');
    if (!gaveta) return false;
    if (gaveta.querySelector('.drawer__inner-empty')) return true;
    return !gaveta.querySelector('.cart-item');
  }

  function doisDigitos(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function pinta(el) {
    var duracao = parseInt(el.getAttribute('data-dl-duration'), 10);
    // data-duration é decrementado pela classe do bundle a cada passagem dela,
    // então fica só como reserva para quem ainda não tem o atributo próprio
    if (!isFinite(duracao) || duracao <= 0) duracao = parseInt(el.getAttribute('data-duration'), 10);
    if (!isFinite(duracao) || duracao <= 0) return;

    var restante;
    if (carrinhoVazio(el)) {
      esquecerPrazo(duracao);
      restante = duracao;
    } else {
      restante = Math.ceil((prazoDe(duracao) - Date.now()) / 1000);
    }

    // rede de segurança: prazoDe já renova antes de zerar, mas nenhum caminho
    // desta função pode terminar imprimindo 00:00
    if (!(restante >= 1)) restante = duracao;
    if (restante > duracao) restante = duracao;

    var texto = doisDigitos(Math.floor(restante / 60)) + ':' + doisDigitos(restante % 60);

    // escrever só quando muda evita realimentar o observador logo abaixo
    if (el.textContent !== texto) el.textContent = texto;
  }

  function passada() {
    var lista = document.querySelectorAll('countdown-timer');
    for (var i = 0; i < lista.length; i++) pinta(lista[i]);
  }

  var agendado = false;
  function agenda() {
    if (agendado) return;
    agendado = true;
    var roda = function () {
      agendado = false;
      passada();
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(roda);
    else setTimeout(roda, 16);
  }

  function iniciar() {
    passada();
    setInterval(passada, 1000);

    // a gaveta inteira é trocada por innerHTML a cada alteração do carrinho e o
    // custom element é remontado do zero, com o número da duração cheia. Guardar
    // referência ao elemento não serve: o que vale é reagir ao redesenho.
    if (window.MutationObserver && document.body) {
      // childList basta: is-empty chega junto com a troca de innerHTML feita
      // pelo adaptador, e a passagem de 1s cobre qualquer sobra
      new MutationObserver(agenda).observe(document.body, { childList: true, subtree: true });
    }
    // aba que volta do segundo plano ou página restaurada do cache acertam na hora
    document.addEventListener('visibilitychange', passada);
    window.addEventListener('pageshow', passada);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
